export const SEARCH_PARAMS_FILTERS = {
  CATEGORY_PARAM: "category",
  PARTNER_PARAM: "partner",
  SHOPPING_MALL_PARAM: "shopping-mall",
  STORE_PARAM: "store",
  RECOMMENDED_PARAM: "recommended",
  SORT_PARAM: "sort",
}